import { useJurisdictionSwitch } from "@dutypay/front-end-design-system/src/composables";
import { get } from "lodash";

const {
  getJurisdictionByLocale,
  setJurisdictionInLocalStorage,
  loadJurisdiction,
  getJurisdictionFromLocalStorage,
  fallbackJurisdiction,
} = useJurisdictionSwitch();

function syncJurisdictionFromQueryParam() {
  const urlLocale = new URLSearchParams(window.location.search).get("i18n");
  if (!urlLocale) return null;

  const jurisdiction = getJurisdictionByLocale(urlLocale);
  if (!jurisdiction) return null;

  setJurisdictionInLocalStorage(jurisdiction);
  return jurisdiction;
}

export async function loadInitialJurisdiction() {
  const jurisdictionFromQueryParam = syncJurisdictionFromQueryParam();
  if (jurisdictionFromQueryParam) {
    return jurisdictionFromQueryParam;
  }

  return loadJurisdiction();
}

function getPersistedJurisdiction() {
  return getJurisdictionFromLocalStorage() || fallbackJurisdiction;
}

export function getPersistedLocale(fallbackLocale = "en-US") {
  return get(getPersistedJurisdiction(), "i18n", fallbackLocale);
}
